let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Aq4t")).then(() => parcelRequire('eZOQw'));